import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import AboutUs_background from "../assets/aboutUs/aboutUs_bg.png"
import projectList from '../assets/projectList';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';



const AboutUsProject = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 100,
    slidesToScroll: 1,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
    className="mx-auto px-4 py-16 md:px-6 lg:px-8 font-manrope relative"
    style={{
      backgroundImage: `url(${AboutUs_background})`,
      backgroundSize: "cover",
      backgroundPosition: "left center",
      backgroundRepeat: "no-repeat",
    }}
  >
    {/* Section Heading */}
      <div className=" flex justify-between  p-6">
      <div className=" mb-4">
        <h3 className="text-[#504e9a] font-semibold mb-4 text-xl sm:text-2xl md:text-xl">PROJECTS</h3>
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
        Our Latest Incredible Client's Projects
        </h1>
      </div>
      <div>
        <Link
          to="/portfolio-grid"
          className="relative hidden  lg:flex bg-[#504e9a] text-white px-6 py-3 font-semibold rounded-full border-2 border-[#504e9a] overflow-hidden transition-transform duration-300 will-change-transform z-0 items-center justify-center group hover:text-[#504e9a] w-full sm:w-auto"
        >
          Our Projects
          <FaArrowRight
            className="ml-2 h-4 w-4 transition-transform -rotate-45 duration-300 transform group-hover:rotate-0"
          />
          <span
            className="absolute inset-0 bg-white rounded-full transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0 will-change-transform z-[-1]"
          ></span>
        </Link>
      </div>
    </div>

    {/* Slider Section */}
    <Slider {...settings}>
      {projectList.map((portfolio, index) => (
        <div
          key={portfolio.id}
          className="my-6"
          onMouseEnter={() => setHoveredCard(portfolio.id)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <Link to={`/portfolio-grid/${portfolio.id}`} className="block">
          <div className="flex flex-col gap-2 shadow-lg mx-6 rounded-3xl relative bg-[#f7f8fd] overflow-hidden">
            <img
              src={portfolio.image}
              alt={portfolio.title}
              loading="lazy"
              className="w-full object-cover rounded-t-3xl"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="bg-white rounded-md shadow-md relative overflow-hidden">
                <div
                  className="w-1 bg-blue-800 absolute left-0 transition-all duration-300"
                  style={{
                    height: hoveredCard === portfolio.id ? "100%" : "24px",
                    top: hoveredCard === portfolio.id ? "0" : "calc(50% - 12px)",
                  }}
                />
                <div className="p-6 pl-8">
                  <p className="text-[#504e9a] font-semibold mb-1">{portfolio.category}</p>
                  <h3 className="text-2xl font-bold text-gray-900">{portfolio.title}</h3>
                </div>
              </div>
            </div>
          </div>
          </Link>
        </div>
      ))}
    </Slider>
  </div>
  );
};

export default AboutUsProject;